import { render, staticRenderFns } from "./PlayAndWinDetail.vue?vue&type=template&id=d46154a2&scoped=true&"
import script from "./PlayAndWinDetail.vue?vue&type=script&lang=js&"
export * from "./PlayAndWinDetail.vue?vue&type=script&lang=js&"
import style0 from "./PlayAndWinDetail.vue?vue&type=style&index=0&id=d46154a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46154a2",
  null
  
)

export default component.exports